import React from 'react';

const CartTable = ({ 
  cart, 
  getDiscountedPrice, 
  onQuantityChange, 
  onDecreaseQuantity, 
  onIncreaseQuantity, 
  onRemoveFromCart 
}) => {
  if (cart.length === 0) {
    return (
      <p className="text-center text-gray-500 mt-2 text-sm">No hay productos en el carrito.</p>
    );
  }

  return (
    <div className="bg-white shadow rounded overflow-hidden">
      {/* Vista de tabla para pantallas medianas y grandes */}
      <div className="hidden md:block">
        <table className="w-full text-xs">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left font-semibold text-gray-700">Cant.</th>
              <th className="p-2 font-semibold text-center text-gray-700">Acc.</th>
              <th className="p-2 text-left font-semibold text-gray-700">Plug</th>
              <th className="p-2 text-left font-semibold text-gray-700">Producto</th>
              <th className="p-2 text-left font-semibold text-gray-700">P.Unit</th>
              <th className="p-2 text-left font-semibold text-gray-700">Subt.</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item) => (
              <tr key={item.id}>
                <td className="p-1 text-gray-800">
                  <input
                    type="number"
                    step="0.001"
                    min="0"
                    max={item.stock_unidades}
                    value={item.quantity}
                    onChange={(e) => onQuantityChange(item.id, e.target.value)}
                    className={`w-12 p-0.5 border rounded text-center text-xs ${!item.quantity ? 'border-red-500' : 'border-gray-300'}`}
                  />
                </td>
                <td className="p-1 flex gap-0.5 justify-center">
                  <button
                    onClick={() => onDecreaseQuantity(item.id)}
                    className="px-2 py-0.5 text-white bg-red-500 rounded hover:bg-red-600 text-xs"
                  >-</button>
                  <button
                    onClick={() => onIncreaseQuantity(item.id)}
                    className="px-2 py-0.5 text-white bg-green-500 rounded hover:bg-green-600 text-xs"
                  >+</button>
                  <button
                    onClick={() => onRemoveFromCart(item.id)}
                    className="px-2 py-0.5 text-white bg-gray-500 rounded hover:bg-gray-600 text-xs"
                  >✕</button>
                </td>
                <td className="p-1 text-gray-700">
                  {item.codigo_barras?.length > 0 ? (
                    <span className="text-[10px] truncate block">{item.codigo_barras[0].codigo}{item.codigo_barras.length > 1 && <span className="ml-1 text-gray-400">+{item.codigo_barras.length - 1}</span>}</span>
                  ) : (
                    <span className="text-gray-300 italic text-[10px]">Sin código</span>
                  )}
                </td>
                <td className="p-1 text-gray-800 truncate max-w-[8rem]">{item.nombre_producto}</td>
                <td className="p-1 text-gray-800">${getDiscountedPrice(item)}</td>
                <td className="p-1 text-gray-800">${(getDiscountedPrice(item) * item.quantity).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Vista de cards para pantallas pequeñas */}
      <div className="md:hidden space-y-2 p-2">
        {cart.map((item) => (
          <div key={item.id} className="border rounded p-2 bg-gray-50">
            <div className="flex justify-between items-start mb-1">
              <div className="flex-1 min-w-0">
                <h3 className="font-medium text-gray-800 truncate text-xs">{item.nombre_producto}</h3>
                {item.codigo_barras?.length > 0 && (
                  <span className="text-[10px] text-gray-400 mt-0.5 block truncate">{item.codigo_barras[0].codigo}{item.codigo_barras.length > 1 && <span className="ml-1">+{item.codigo_barras.length - 1}</span>}</span>
                )}
              </div>
              <button
                onClick={() => onRemoveFromCart(item.id)}
                className="ml-1 text-red-500 hover:text-red-700 text-xs"
              >✕</button>
            </div>
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-1">
                <button
                  onClick={() => onDecreaseQuantity(item.id)}
                  className="px-1.5 py-0.5 text-white bg-red-500 rounded text-xs"
                >-</button>
                <input
                  type="number"
                  step="0.001"
                  min="0"
                  max={item.stock_unidades}
                  value={item.quantity}
                  onChange={(e) => onQuantityChange(item.id, e.target.value)}
                  className={`w-12 p-0.5 border rounded text-center text-xs ${!item.quantity ? 'border-red-500' : 'border-gray-300'}`}
                />
                <button
                  onClick={() => onIncreaseQuantity(item.id)}
                  className="px-1.5 py-0.5 text-white bg-green-500 rounded text-xs"
                >+</button>
              </div>
              <div className="text-right">
                <div className="text-xs text-gray-600">${getDiscountedPrice(item)} c/u</div>
                <div className="font-bold text-green-700 text-xs">
                  ${(getDiscountedPrice(item) * item.quantity).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartTable;
